import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import HeaderBackendComponent from "../../components/Header/headerBackendMobile";
import AddProductsComponent from "../../components/products/addProduct";



const AddProductsView = () => (
  <Container  className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Product toevoegen" subtitle="JesseFresh" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <HeaderBackendComponent />
    <AddProductsComponent />
    
  </Container>
);

export default AddProductsView;
